// Custom popper to prevent clipping
import Popper, {PopperProps} from "@mui/material/Popper";
import React from "react";

export const CustomPopper = (props: PopperProps) => {
    const width = React.useMemo(() => {
        // Check if anchorEl is an HTML element that has clientWidth
        if (props.anchorEl && 'clientWidth' in props.anchorEl) {
            return `${(props.anchorEl as HTMLElement).clientWidth}px`;
        }
        return undefined;
    }, [props.anchorEl]);
    return <Popper
        {...props}
        placement="bottom-start"
        disablePortal={false}
        modifiers={[
            {
                name: 'preventOverflow',
                enabled: true,
                options: {
                    altAxis: true,
                    altBoundary: true,
                    boundary: document.body,
                    rootBoundary: 'viewport',
                },
            },
        ]}
        style={{
            zIndex: 1500,
            width,
        }}
    />;
};